import { cn } from '@/lib/utils';
import { Button } from './button';
import Link from 'next/link';
interface CompaniesHeroProps {
  title: string;
  subtitle: string;
  cta?: React.ReactNode;
  className?: string;
}

export function CompaniesHero({
  title,
  subtitle,
  className
}: CompaniesHeroProps) {
  return (
    <div className="relative mt-16 lg:mt-0 lg:h-[90vh] overflow-hidden">
      <div
        className={cn(
          'flex flex-col justify-center items-center space-y-6 md:space-y-8 w-full relative px-4 py-16 md:py-24 lg:py-32',
          className
        )}
      >
        <div className="flex flex-col items-center space-y-3 md:space-y-4 gap-2 max-w-4xl z-10">
          <h1 className="font-bold text-center leading-tight md:leading-none text-4xl sm:text-5xl md:text-6xl xl:text-8xl font-domaine-narrow">
            {title}
          </h1>
          <p className="font-inter text-sm sm:text-base md:text-lg lg:text-2xl text-center max-w-xl px-2">
            {subtitle}
          </p>
          <Link href="/signup?role=company">
            <Button size="xl" className="mt-2 text-white text-lg md:text-xl">
              Start hiring
            </Button>
          </Link>
        </div>
        <div className="max-w-5xl mx-auto py-4 md:py-8 overflow-x-auto w-full">
          <div className="flex flex-col md:flex-row gap-3 md:gap-4 justify-center items-center min-w-max px-4">
            <span className="uppercase font-semibold text-xs md:text-sm text-gray-700">
              3-Week Trial
            </span>

            <hr className="hidden md:block w-8 lg:w-16" />
            <div className="md:hidden w-full h-px bg-gray-300"></div>

            <span className="uppercase font-semibold text-xs md:text-sm text-gray-700">
              Healthcare Included
            </span>

            <hr className="hidden md:block w-8 lg:w-16" />
            <div className="md:hidden w-full h-px bg-gray-300"></div>

            <span className="uppercase font-semibold text-xs md:text-sm text-gray-700">
              Illness Cover
            </span>

            <hr className="hidden md:block w-8 lg:w-16" />
            <div className="md:hidden w-full h-px bg-gray-300"></div>

            <span className="uppercase font-semibold text-xs md:text-sm text-gray-700">
              Background screening
            </span>
          </div>
        </div>
      </div>

      <div className="flex justify-center w-full">
        <video
          src="/taj-bg.mp4"
          autoPlay
          muted
          loop
          controls={false}
          preload="auto"
          playsInline
          className="absolute top-0 right-0 md:-right-40 xl:-right-80 opacity-20 aspect-video z-0 w-full  overflow-hidden"
        />
      </div>
    </div>
  );
}
